<template>
    <v-container>
        <SelectorAgenda></SelectorAgenda>
        <v-row align="center" class="my-4" no-gutters>
            <v-col cols="12" md="6">
                <div class="titulo my-4 px-4">
                    <h1
                        class="font-weight-bold"
                        :class="esMovil ? 'text-h6' : 'text-h5'"
                        :style="colorTitulo"
                    >
                        {{ datosHashag.titulo }}
                    </h1>
                </div>
            </v-col>
            <v-col cols="6" v-if="!esMovil">
                <v-row align="center" justify="center">
                    <v-img :src="datosHashag.iconoGrupo" max-width="50" class="mr-2">
                    </v-img>
                    <span class="objetivo-hashtag">{{ datosHashag.nombreGrupo }}</span>
                </v-row>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="12" class="px-4">
                <div class="descripcion-hashtag font-weight-bold" v-if="esMovil">
                    {{
                        $t("lista-indicadores.texto.pertenecencia-objetivo", {
                            nombreGrupo: datosHashag.nombreGrupo,
                        })
                    }}
                </div>
                <div class="descripcion-hashtag mb-4">
                    {{ datosHashag.descripcion }}
                </div>
            </v-col>
        </v-row>
        <ListaIndicadores
            v-if="listaIndicadores.length > 0"
            :listaIndicadores="listaIndicadores"
            :esUltimaPagina="esUltimaPagina"
            @cargarMasIndicadores="scrollInfinito"
        ></ListaIndicadores>
        <v-row justify="center" v-else>
            <v-col v-if="cargandoListaIndicadores" cols="12" class="text-center">
                <v-progress-circular
                    size="50"
                    indeterminate
                    color="primary"
                ></v-progress-circular>
            </v-col>
            <v-col v-else cols="12">
                <v-card>
                    <v-card-text>
                        {{ $t("detalles.texto.no-hay-indicadores") }}
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import ListaIndicadores from "@components/ListaIndicadores.vue";
import SelectorAgenda from "@components/SelectorAgenda.vue";
import IndicadoresService from "@services/IndicadoresService.js";
import MasterdataService from "@services/MasterdataService";

export default {
    name: "listadoHashtag",
    props: ["id"],
    components: {
        ListaIndicadores,
        SelectorAgenda,
    },
    data: () => ({
        datosHashag: {
            nombre: "",
            nombreGrupo: "",
            descripcion: "",
            color: "#FFF",
        },
        pagina: 1,
        ultimaPagina: 10,
        listaIndicadores: [],
        cargandoListaIndicadores: false,
        timeout: null,
    }),
    computed: {
        titulo() {
            return this.id && this.enlacesObjetivos.length > 0
                ? this.enlacesObjetivos[this.id - 1].texto
                : this.$t("indicadores.texto.titulo-defecto");
        },
        colorTitulo() {
            return {
                "background-color": this.datosHashag.color,
                display: "inline-block",
                color: "#FFF",
            };
        },
        esUltimaPagina() {
            return this.pagina >= this.ultimaPagina;
        },
        esMovil() {
            return this.$vuetify.breakpoint.smAndDown;
        },
    },
    methods: {
        recargarLista() {
            this.pagina = 1;
            this.ultimaPagina = 10;
            this.listaIndicadores = [];
            this.actualizarInformacionHashtag();
            this.actualizarListaIndicadores();
        },

        cambiarFiltro() {
            this.recargarLista();
        },

        actualizarListaIndicadores() {
            if (this.cargandoListaIndicadores) {
                return;
            }

            let params = {
                page: this.pagina,
                idHashtag: this.id,
                filtroAgenda: this.$route.query.filtroAgenda,
            };

            this.cargandoListaIndicadores = true;
            IndicadoresService.getIndicadores(params)
                .then((response) => {
                    this.ultimaPagina = response.data.last_page;
                    response.data.data.forEach((indicador) =>
                        this.listaIndicadores.push(indicador)
                    );
                })
                .catch((error) => {
                    this.pagina = 1;
                    this.ultimaPagina = 1;
                    this.listaIndicadores = [];
                })
                .finally(() => {
                    this.cargandoListaIndicadores = false;
                });
        },

        actualizarInformacionHashtag() {
            MasterdataService.getInfomacionHashtags(this.id).then((response) => {
                let datosHashtag = response.data;
                this.datosHashag = {
                    ...datosHashtag,
                    descripcion: this.$t(datosHashtag.descripcion),
                    nombreGrupo: this.$t(datosHashtag.nombreGrupo),
                    titulo: "#" + this.$t(datosHashtag.titulo),
                };
            });
        },

        //Carga mas indicadores cuando se llega al final de la pagina
        scrollInfinito() {
            if (this.esUltimaPagina || this.timeout) clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.pagina++;
                this.actualizarListaIndicadores();
            }, 1000);
        },
    },

    watch: {
        id() {
            this.recargarLista();
        },
        "$route.query.filtroAgenda"() {
            this.cambiarFiltro();
        },
    },
    mounted() {
        this.recargarLista();
    },
};
</script>

<style scoped></style>
